import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit"
import createSagaMiddleware from "redux-saga"
import rootReducer from "./reducers"
import rootSaga from "./sagas"
import apiErrorMiddleware from "middleware/apiErrorMiddleware"

const sagaMiddleware = createSagaMiddleware()

// Function to initialize state from localStorage
const initializeStateFromLocalStorage = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser"))
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true"
  const userRole = authUser ? authUser.role : []
  const accountType = localStorage.getItem("accountType")
  const accountScope = localStorage.getItem("accountScope")
  const userId =
    authUser?._id ||
    authUser?.id ||
    authUser?.userId ||
    authUser?.user?._id ||
    authUser?.user?.id ||
    null
  return {
    Login: {
      authUser: authUser || {},
      isLoggedIn,
      userRole,
      accountType,
      accountScope,
      userId,
      userIntegrations: Array.isArray(authUser?.integrations)
        ? authUser.integrations
        : [],
      planSocialLogins:
        authUser?.planSocialLogins && typeof authUser.planSocialLogins === "object"
          ? {
              google: authUser.planSocialLogins.google === true,
              apple: authUser.planSocialLogins.apple === true,
            }
          : { google: false, apple: false },
    },
  }
}

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(sagaMiddleware, apiErrorMiddleware),
  preloadedState: initializeStateFromLocalStorage(), // Initialize state from localStorage
  devTools: false,
})

sagaMiddleware.run(rootSaga)

export default store
